import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {userRegister} from "../../services/userRegister";
import TextareaAutosize from 'react-autosize-textarea';
import {langRegister} from "../../services/langRegister";
import innerHtml from 'react-inner-html';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {scraperRegister} from "../../services/scraperRegister";
import BoosterHeader from "../../components/booster-header/component";
import {flowRegister} from "../../services/flowRegister";
import {themeRegister} from "../../services/themeRegister";
import {yieldlockRegister} from "../../services/yieldlockRegister";
import {tokenRegister} from "../../services/tokenRegister";
import Moment from "react-moment";
import {agentRegister} from "../../services/agentRegister";

class BoosterAgents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            selected: {},
            isLoadingButton: false,
            isLoading: true,
            agents: [],
            agentEmailScraper: ""
        };
    };

    componentDidMount() {
        let token = tokenRegister.getToken();
        if (!token) {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }
    }

    componentWillMount() {

        agentRegister.remove();

        window.scrollTo(0, 0);
        this._updateUser();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/agents');
            ReactGA4.send({ hitType: "pageview", page: "/booster/agents" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

        //FETCH BROKER EMAIL SCRAPER
        let scraper_data = JSON.parse(scraperRegister.get());
        try {
            if (scraper_data.additional_information.broker) {
                this.setState({
                    agentEmailScraper: scraper_data.additional_information.broker.email ? scraper_data.additional_information.broker.email : ""
                }, () => { console.log(this.state.agentEmailScraper); });
            }
        } catch (e) {}

    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                let agents = [];
                if(Array.isArray(user.agents) && user.agents.length > 0){
                    agents = user.agents;
                }
                user.admin = true;
                agents.unshift(user);
                this.setState({
                    reseller: user.reseller,
                    inhouse: user.inhouse,
                    agents: agents,
                    isLoading: false
                });
            }else{

            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _select(profile){
        agentRegister.set(profile);
        if(salesChannelRegister.get('name') === "yieldlock"){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry");
        }else{
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
        }
    }

    _renderText(item) {
        return langRegister.get("booster-agents", item);
    }

    render() {
        return (
            <div>
                <BoosterHeader view={"signup"} props={this.props}/>
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        {
                            !this.state.error &&
                            <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}} className={Styles.title}>
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}>
                                    {this._renderText("item_1")}
                                </div>
                            </div>
                        }
                        {
                            this.state.agents.sort((a, b) => {
                                if (a.admin && !b.admin) {
                                    return -1; // Move agent a with #admin to a lower index
                                } else if (!a.admin && b.admin) {
                                    return 1; // Move agent b with #admin to a higher index
                                }

                                if (a.admin && !b.admin) {
                                    return -1; // Move agent a with #admin to a lower index
                                } else if (b.admin && !a.admin) {
                                    return 1; // Move agent b with #admin to a higher index
                                }

                                if (a.email === this.state.agentEmailScraper && b.email !== this.state.agentEmailScraper) {
                                    return -1; // Move agent a with agentEmailScraper to a lower index
                                } else if (a.email !== this.state.agentEmailScraper && b.email === this.state.agentEmailScraper) {
                                    return 1; // Move agent b with agentEmailScraper to a higher index
                                }

                                // Sort remaining agents by name in ascending order
                                return a.name.localeCompare(b.name);
                            }).map((item) => {
                                return(
                                    <div className={Styles.contentInnerItem}>
                                        <div className={Styles.contentInnerItemHeader}>
                                            <div className={Styles.contentInnerItemHeaderImage}>
                                                <img className={Styles.contentInnerItemHeaderImageItem} src={item.profile_image}/>
                                            </div>
                                            <div className={Styles.contentInnerItemHeaderTitle}>
                                                {item.name}{item.email === this.state.agentEmailScraper ? " ●" : ""}
                                            </div>
                                            {
                                                item.admin &&
                                                <div className={Styles.contentInnerItemHeaderIndustry}>
                                                    #admin
                                                </div>
                                            }
                                            <div className={Styles.contentInnerItemHeaderId}>

                                            </div>
                                            <div className={Styles.cardStatusContainer}>

                                            </div>
                                            <div onClick={() => {
                                                this._select(item);
                                            }} className={cx(Styles.contentInnerItemHeaderEdit,
                                                {
                                                    [Styles.contentInnerItemHeaderEditYieldlock]: salesChannelRegister.get('name') === 'yieldlock'
                                                })}>
                                                {this._renderText("item_2")}
                                            </div>
                                                <div onClick={() => this._select(item)}
                                                     className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen,
                                                         {
                                                             [Styles.contentInnerItemHeaderEditMobileGreenYieldlock]: salesChannelRegister.get('name') === 'yieldlock'
                                                         })}>
                                                </div>

                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
            </div>
        );
    }
}

export default BoosterAgents;


// WEBPACK FOOTER //
// ./src/pages/booster-agents/component.js